import schedulePatterns from "./schedulePatterns";

const rootStore = {
  schedulePatterns
};

export default rootStore;
